import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { retry } from "rxjs/operators";
import { TAny, TResponseValueType } from "../models/common.type";
import { IHttpOptions } from "../models/http-options.model";
import { IResponse } from "../models/response.model";
import { AppConfiguration } from "./app-config.service";

@Injectable({
    providedIn: 'root'
})
export abstract class AbstractHttpBaseService {

    constructor(protected http: HttpClient, protected appConfig: AppConfiguration) { }

    protected abstract handleError(data: IResponse<TAny>): void;

    protected get serviceUrl(): string { return this.appConfig.hostUrl; }

    protected get noOfAttempts(): number { return this.appConfig.data.noOfAttempts || 1 }

    public get<T>(url: string, params: IHttpOptions = {}): Observable<T> {
        return this.http.get<T>(`${this.serviceUrl}${url}`, { ...params, params: { ...(params.params || {}), _dc: new Date().getTime() } })
            .pipe(
                retry(this.noOfAttempts)
            )
    }

    public post<T, BodyT>(url: string, body?: BodyT, params: IHttpOptions = {}): Observable<T> {
        return this.http.post<T>(`${this.serviceUrl}${url}`, body, { ...params });
    }

    public put<T, BodyT>(url: string, body?: BodyT, params: IHttpOptions = {}): Observable<T> {
        return this.http.put<T>(`${this.serviceUrl}${url}`, body, { ...params });
    }

    public delete<T>(url: string, params: IHttpOptions = {}): Observable<T> {
        return this.http.delete<T>(`${this.serviceUrl}${url}`, { ...params });
    }

    public prepareresponse<T>(res: IResponse<T | T[] | null>, returnDataType: TResponseValueType = 'S'): T | null {
        if (res && typeof res === 'object') {
            if (res.success) {
                return (returnDataType == 'A' ? res.data : (res.data as T[])?.[0]) as T;
            } else if (res.errors) {
                this.handleError(res);
            } else {
                return returnDataType == 'A' ? [] as T : null;
            }
        }
        return null;
    }

}